module.exports = __webpack_public_path__ + "assets/img/img155.14ea0cbf.png";